/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:55:36
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 16:15:38
 */
import req from "@/utils/request";

// 变量分组列表
export const variableGrouplist = (params) => req.post("/site-service/m/site/variableGroup/list", params);

// 新增变量分组
export const AddVariableGroup = (params) => req.post("/site-service/m/site/variableGroup/add", params);

// 新增变量分组
export const updateVariableGroup = (params) => req.post("/site-service/m/site/variableGroup/update", params);

// 删除变量分组
export const variableGroupDel = (params) => req.post("/site-service/m/site/variableGroup/del", params);

// 变量列表
export const variableList = (params) => req.post("/site-service/m/site/variable/list", params);

// 新增变量
export const variableAdd = (params) => req.post("/site-service/m/site/variable/add", params);

// 删除变量
export const variableDel = (params) => req.post("/site-service/m/site/variable/del", params);

// 变量调用
export const variableUse = (params) => req.post("/site-service/m/site/variable/use", params);

// 变量详情
export const variableDetail = (params) => req.post("/site-service/m/site/variable/detail", params);

// 编辑变量
export const variableUpdate = (params) => req.post("/site-service/m/site/variable/update", params);

// 编辑变量
export const groupUp = (params) => req.post("/site-service/m/site/variableGroup/up", params);

// 编辑变量
export const groupDown = (params) => req.post("/site-service/m/site/variableGroup/down", params);